import { DISTANCE_TYPE } from '../enums/route.enum';

export class RouteDirection {
    readonly ToMiles: number = 1609.344;
    readonly ToKm: number = 1000;

    DistanceType: DISTANCE_TYPE = DISTANCE_TYPE.MILES;

    constructor() {}

    getDistanceFormat(): number {
      return ( this.DistanceType == DISTANCE_TYPE.MILES ) ? this.ToMiles : this.ToKm;
    }

    public timeConversion(nanoSeconds, includeSeconds: boolean = false) {
      const ms = nanoSeconds % 1000;
        nanoSeconds = (nanoSeconds - ms) / 1000;
      const secs = nanoSeconds % 60;
        nanoSeconds = (nanoSeconds - secs) / 60;
      const minutes = nanoSeconds % 60;
      const hours = (nanoSeconds - minutes) / 60;

      const timeStr: Array<string> = [];
      // timeStr.push( (days > 0 ) ? days + ' days' : '');
      timeStr.push( (hours > 0) ? hours + ' hours' : '');
      timeStr.push( (minutes > 0 ) ? minutes + ' mins' : '');

      if (includeSeconds && hours <= 0) {
        timeStr.push( (secs > 0 ) ? secs + ' s' : '');
      }
      return timeStr.join(' ');
    }
  }
